<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout row wrap justify-center>
          <!-- IMAGE DATABSES ADMIN SECTION -->
          <v-flex
            class="py-0 pb-1 pt-0 px-1"
            xs12
            v-if="
              ($store.state.storeAuth.userProfile.isSuperAdmin &&
                $store.state.storeAuth.userProfile.client ==
                  $store.state.storeClient.client.basicSettings.name) ||
                $store.state.storeAuth.userProfile.isSuperStoreAdmin
            "
          >
            <v-card
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray'
                  : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-image-edit</v-icon
                >
                {{ $t("settingsSubMenuModuleImageDatabasesTitle") }}
              </v-card-title>
              <v-card-actions
                class="d-flex flex-wrap align-stretch"
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke'
                    : 'background-color: white'
                "
              >
                <!-- BACKGROUND CATEGORYS-->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabaseCategory/${G_IMAGE_DATABASE_TYPE_BACKGROUNDS}`
                  "
                  icon="mdi-clipboard-text-outline"
                  :title="$t('dashboardCardSuperAdminBackgroundsCatDatabase')"
                ></home-menu-admin-btn>
                <!-- BACKGROUNDS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabase/${G_IMAGE_DATABASE_TYPE_BACKGROUNDS}`
                  "
                  icon="mdi-image"
                  :title="$t('dashboardCardSuperAdminBackgroundsDatabase')"
                ></home-menu-admin-btn>
                <!-- PATTERNS CATEGORYS-->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabaseCategory/${G_IMAGE_DATABASE_TYPE_PATTERNS}`
                  "
                  icon="mdi-clipboard-text-outline"
                  :title="$t('dashboardCardSuperAdminPatternsCatDatabase')"
                ></home-menu-admin-btn>
                <!-- PATTERNS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabase/${G_IMAGE_DATABASE_TYPE_PATTERNS}`
                  "
                  icon="mdi-dots-grid"
                  :title="$t('dashboardCardSuperAdminPatternsDatabase')"
                ></home-menu-admin-btn>
                <!-- FRAMES CATEGORYS-->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabaseCategory/${G_IMAGE_DATABASE_TYPE_FRAMES}`
                  "
                  icon="mdi-clipboard-text-outline"
                  :title="$t('dashboardCardSuperAdminFramesCatDatabase')"
                ></home-menu-admin-btn>
                <!-- FRAMES -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabase/${G_IMAGE_DATABASE_TYPE_FRAMES}`
                  "
                  icon="mdi-border-outside"
                  :title="$t('dashboardCardSuperAdminFramesDatabase')"
                ></home-menu-admin-btn>
                <!-- STICKERS CATEGORYS-->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabaseCategory/${G_IMAGE_DATABASE_TYPE_STICKERS}`
                  "
                  icon="mdi-clipboard-text-outline"
                  :title="$t('dashboardCardSuperAdminStickersCatDatabase')"
                ></home-menu-admin-btn>
                <!-- STICKERS -->
                <home-menu-admin-btn
                  :allow="
                    ($store.state.storeAuth.userProfile.isSuperAdmin &&
                      $store.state.storeAuth.userProfile.client ==
                        $store.state.storeClient.client.basicSettings.name) ||
                      $store.state.storeAuth.userProfile.isSuperStoreAdmin
                  "
                  :path="
                    `/settingsImageDatabase/${G_IMAGE_DATABASE_TYPE_STICKERS}`
                  "
                  icon="mdi-sticker-emoji"
                  :title="$t('dashboardCardSuperAdminStickersDatabase')"
                ></home-menu-admin-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import HomeMenuAdminBtn from "@/components/HomeMenuAdminBtn";
import {
  G_IMAGE_DATABASE_TYPE_BACKGROUNDS,
  G_IMAGE_DATABASE_TYPE_PATTERNS,
  G_IMAGE_DATABASE_TYPE_FRAMES,
  G_IMAGE_DATABASE_TYPE_STICKERS
} from "@/constants";

export default {
  name: "settingsSubMenuImageDatabase",
  components: {
    AppNavigation,
    SimpleNavigationButton,
    HomeMenuAdminBtn
  },
  created() {
    this.G_IMAGE_DATABASE_TYPE_BACKGROUNDS = G_IMAGE_DATABASE_TYPE_BACKGROUNDS;
    this.G_IMAGE_DATABASE_TYPE_PATTERNS = G_IMAGE_DATABASE_TYPE_PATTERNS;
    this.G_IMAGE_DATABASE_TYPE_FRAMES = G_IMAGE_DATABASE_TYPE_FRAMES;
    this.G_IMAGE_DATABASE_TYPE_STICKERS = G_IMAGE_DATABASE_TYPE_STICKERS;
  }
};
</script>
<style scoped>
.item {
  margin: 5px;
  padding: 5px;
  width: 100px;
  text-align: center;
}
</style>
